import { addContentLogAPI } from '@/api/logServiceApi';
import { ref } from 'vue';
import { DEV_MODE } from '@/config/dev-mode';

export function usePopups() {
  // 사주간지 박스
  const isPopGanjiBox = ref(false);

  const openPopGanjiBox = () => {
    addContentLogAPI('M_saju_ganji_check');
    isPopGanjiBox.value = true;
  };
  // 지역 검색
  const isPopAreaBox = ref(false);

  const handleFocusArea = () => {
    // formData.value.option4 = true
    if (!isPopAreaBox.value) {
      addContentLogAPI('');
      isPopAreaBox.value = true;
    }
  };

  // 좌측 배너 클릭시 팝업
  const isPopQrBox = ref(false);

  const qrOpen = () => {
    isPopQrBox.value = true;
  };
  const closePopQrBox = () => (isPopQrBox.value = false);

  // 퀵메뉴 팝업
  const isPopQuickMenu = ref(false);

  const openPopQuickMenu = () => {
    isPopQuickMenu.value = true;
  };
  const closePopQuickMenu = () => (isPopQuickMenu.value = false);

  // 옵션 툴팁 팝업
  const clickTooltip = (type) => {
    const args = {
      contentType: 'manse_btn_click_tooltip_opt3',
      option3: type,
    };
    addContentLogAPI(args);
    openPopOption(type);
  };

  /** 옵션 팝업 열기 */
  const isOpenPopKSTOption = ref(false);
  const isOpenPopJasiOption = ref(false);
  const isOpenPopSTOption = ref(false);

  const openPopOption = (option) => {
    if (option === '한국시') {
      isOpenPopKSTOption.value = true;
    } else if (option === '야자시') {
      isOpenPopJasiOption.value = true;
    } else if (option === '절기') {
      isOpenPopSTOption.value = true;
    } else {
      DEV_MODE && console.log('옵션 팝업 오류입니다');
    }
  };

  /** 옵션 팝업 닫기 */
  const closePopOption = (option) => {
    switch (option) {
      case 'KST':
        isOpenPopKSTOption.value = false;
        break;
      case 'Jasi':
        isOpenPopJasiOption.value = false;
        break;
      case 'ST':
        isOpenPopSTOption.value = false;
        break;
    }
  };

  // 서머타임 팝업
  const isPopSummerTime = ref(false);

  const openSummerTime = () => {
    addContentLogAPI({
      contentType: 'manse_btn_click_tooltip_opt3',
      option3: '서머타임',
    });
    isPopSummerTime.value = true;
  };

  // 갤러리형 용어 설명
  const isPopManseDetail = ref(false);
  const closePopManseDetail = () => {
    isPopManseDetail.value = false;
  };

  /** 용어 설명 팝업 열기 */
  const openDetail = (index) => {
    currentCardIndex.value = index;
    isPopManseDetail.value = true;
    addContentLogAPI({
      contentType: pgmode.value === 'rs' ? 'sl_saju_card_popup_opt3' : 'manse_saju_card_popup_opt3',
      option3: `${contentOptionMap[index]}`,
    });
  };

  return {
    // 상태 (State)
    isPopGanjiBox,
    isPopAreaBox,
    isPopQrBox,
    isPopQuickMenu,
    isOpenPopKSTOption,
    isOpenPopJasiOption,
    isOpenPopSTOption,
    isPopSummerTime,
    isPopManseDetail,

    // 함수 (Actions)
    openPopGanjiBox,
    handleFocusArea,
    qrOpen,
    closePopQrBox,
    openPopQuickMenu,
    closePopQuickMenu,
    clickTooltip,
    openPopOption,
    closePopOption,
    openSummerTime,
    closePopManseDetail,
  };
}
